import { React, Fragment, memo, useEffect, useState } from 'react'

import {
  HeadingText,
  BodyText,
  Divider,
  Button,
  Row,
  Col,
  Link,
  V2ContactUsIcon,
  Checkbox,
  Alert,
  LoadingSpinner,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import {
  fptiCustomSetup,
  fptiCustomClick,
  getFeatureValue,
} from '../../../utils'
import {
  PYPL_CONTACTUS_URL,
  PRIVACY_STATEMENT_LINK,
  DATA_DELETION_LINKED_ACCOUNTS_API,
} from '../../../constants/constants'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import asASlide from '../../common/as-a-slide'
import serverData from '../../../utils/server-data'
import { post } from '../../../utils/ajax.js'
const { locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

const DataDeletion = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION
  const linkedAccountsFpti = DATAPRIVACY_FPTI.LINKED_ACCOUNTS

  const [impressionDone, setImpressionDone] = useState(false)
  const {
    onModalNavigate,
    modalParams: { submitError = false, linkedAccounts = [] } = {},
    updateModalStore,
  } = props
  const [confirmCheckbox, setConfirmCheckbox] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [privacyURL, setPrivacyURL] = useState('')
  const [showAlertOnTop, setshowAlertOnTop] = useState(submitError)
  const [showSpinner, setShowSpinner] = useState(false)
  const noBalanceEnabledCountriesKey = getFeatureValue(
    'noBalanceEnabledCountries',
  )
  const handleContinueClick = (event) => {
    event.preventDefault()
    if (confirmCheckbox) {
      setShowAlert(false)
      setshowAlertOnTop(false)
      fptiCustomClick(deletionFpti.CONTINUE_BTN)
      if (linkedAccounts.length) {
        onModalNavigate(1)
      } else if (
        serverData.closeUrl &&
        serverData.closeUrl.includes('myaccount/preferences/close-account')
      ) {
        onModalNavigate(2)
      } else {
        postLinkedAccountsRequest()
      }
    } else {
      setShowAlert(true)
    }
  }

  async function postLinkedAccountsRequest() {
    setShowSpinner(true)

    const reqparams = {
      _csrf: serverData._csrf,
    }

    const response = await post(DATA_DELETION_LINKED_ACCOUNTS_API, reqparams)

    if (response.success) {
      setShowSpinner(false)
      if (response && response.data && response.data['data-response']) {
        fptiCustomClick(linkedAccountsFpti.LINKED_ACCOUNTS_FOUND)
        updateModalStore({ linkedAccounts: response.data.linkedAccounts })
        onModalNavigate(1)
      } else {
        onModalNavigate(2)
      }
    } else {
      setShowSpinner(false)
      setshowAlertOnTop(true)
    }
  }

  const onClickPrivacyLink = (event) => {
    event.preventDefault()
    fptiCustomClick(deletionFpti.PRIVACY_LINK)
    location.href = privacyURL
  }
  const onClickContactUs = (event) => {
    event.preventDefault()
    fptiCustomClick(deletionFpti.CONTACTUS_LINK)
    location.href = PYPL_CONTACTUS_URL
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(deletionFpti.IMPRESSION)
    }

    //set privacylink url
    const privacyLink = `https://${serverData.cdnPayPalDomain}${PRIVACY_STATEMENT_LINK}`
    setPrivacyURL(privacyLink)
  }, [])

  const handleConfirmCheckbox = (event) => {
    const checkedValue = event.target.checked
    setConfirmCheckbox(checkedValue)
  }
  let noBalanceKeyExtension = ''
  if (
    noBalanceEnabledCountriesKey.includes(serverData.country) &&
    serverData.isNoBalanceUser
  ) {
    noBalanceKeyExtension = '_noBalance'
  }

  return (
    <Fragment>
      {showSpinner ? (
        <div className="requestForm-spinner">
          <LoadingSpinner screenReaderText="loading" size="lg" theme="v2" />
        </div>
      ) : (
        <Fragment>
          <HeadingText id="dataDeletionHeader" size="lg">
            <Message id="dataErasure.section.heading" />
          </HeadingText>
          {showAlertOnTop && (
            <Alert
              theme="v2"
              className="requestForm-row"
              type="error"
              closeButton={{
                onClick: () => {
                  setshowAlertOnTop(false)
                },
              }}
            >
              <Message id={'dar.header.alert.fail'} />
            </Alert>
          )}
          <BodyText className="dataPrivacy-row">
            <Message id="dataErasure.section.description" />
          </BodyText>
          <Divider secondary theme="v2" />
          <Row className="dataPrivacy-row">
            <Col>
              <HeadingText size="sm">
                <Message id="dataErasure.section.deletionQuestion" />
              </HeadingText>
            </Col>
          </Row>
          <Row className="dataDeletion-list">
            <Col>
              <ul className="dataDeletion-listOrder">
                <li className="dataDeletion-listOrder-item">
                  <BodyText className="dataDeletion-textItem">
                    <Message id="dataErasure.section.firstPoint" />
                  </BodyText>
                </li>
                <li className="dataDeletion-listOrder-item">
                  <BodyText className="dataDeletion-textItem">
                    <Message id="dataErasure.section.secondPoint" />
                  </BodyText>
                </li>
                <li className="dataDeletion-listOrder-item">
                  <BodyText className="dataDeletion-textItem">
                    <Message
                      id={`dataErasure.section.thirdPoint${noBalanceKeyExtension}`}
                    />
                  </BodyText>
                </li>
                <li className="dataDeletion-listOrder-item">
                  <BodyText className="dataDeletion-textItem">
                    <Message
                      id={`dataErasure.section.fourthPoint${noBalanceKeyExtension}`}
                    />
                  </BodyText>
                </li>
              </ul>
            </Col>
          </Row>
          <Divider secondary theme="v2" />
          <div className="dataDeletion-msg-info">
            <BodyText className="dataPrivacy-row">
              <Message
                id="dataErasure.section.deletionNoteWithLink"
                link={(innerMessage) => (
                  <Link
                    href={privacyURL}
                    onClick={onClickPrivacyLink}
                    id="privacy_statment_link"
                    theme="v2"
                  >
                    {innerMessage}
                  </Link>
                )}
              />
            </BodyText>
            <BodyText>
              <Message id="dataErasure.section.deletionInfo" />
            </BodyText>
          </div>
          <div className="dataDeletion-contactus">
            <V2ContactUsIcon size="sm" />

            <BodyText className="dataDeletion-contactus-info">
              <Message
                id="dataErasure.section.contactLink"
                link={(innerMessage) => (
                  <Link
                    href={PYPL_CONTACTUS_URL}
                    onClick={onClickContactUs}
                    id="contactus_link"
                    theme="v2"
                  >
                    {innerMessage}
                  </Link>
                )}
              />
            </BodyText>
          </div>
          <Divider secondary theme="v2" />

          <Row>
            <Col dir={directionality}>
              <Checkbox
                theme="v2"
                label={<Message id="dataErasure.section.confirmCheckbox" />}
                checked={confirmCheckbox}
                name="confirmCheckbox"
                id="delete_confirm_checkbox"
                error={showAlert}
                errorText={<Message id="dar.section.submit.fail" />}
                onChange={handleConfirmCheckbox}
                autoComplete="off"
              />
            </Col>
          </Row>

          <Row className="dataPrivacy-row">
            <Col>
              <HeadingText size="sm">
                <Message id="dataErasure.section.note" />
              </HeadingText>
            </Col>
          </Row>
          <Row className="dataPrivacy-btn-row">
            <Col sm={6} md={6}>
              <Button
                theme="v2"
                id="continueBtn"
                size="ld"
                onClick={handleContinueClick}
                className="dataPrivacy-btn-fullwidth"
              >
                <Message id="dataErasure.section.continueButton" />
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  )
})
DataDeletion.displayName = 'DataDeletion'
export default asASlide({ position: 0 })(DataDeletion)
